<template>

  <div class="bg-gray-200 min-h-screen">

    <NavbarComponent/>
    
    <div class="relative px-4 md:px-10 lg:px-24 mx-auto w-full bg-cover bg-center pb-64" :style="{ backgroundImage: 'url(' + require('@/assets/background.png') + ')', '-webkit-clip-path': 'polygon(0 0, 100% 0, 100% 75%, 0 100%)', 'clip-path': 'polygon(0 0, 100% 0, 100% 75%, 0 100%)' }">
      <div class="container mx-auto">

        <slot name="header"></slot>

      </div>
    </div>

    <div class="w-full pb-9">
      <div class="px-4 md:px-10 lg:px-24 mx-auto w-full -mt-64">
        <div class="flex justify-center">

          <slot name="content"></slot>
      
        </div>
      </div>
    </div>

  </div>

  <footer class="w-full py-5 bg-black flex flex-row items-center justify-center text-white font-semibold text-sm">
      © 2025 Desarrollado por <a href="https://qreventos.com" target="qreventos">&nbsp;QREventos</a>
  </footer>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NavbarComponent from '@/components/commons/NavbarComponent.vue';

export default defineComponent({  
  components: {
    NavbarComponent
  }  
});
</script>